type TranslateFn = (key: string, fallback: string) => string

// Purchase-channel facet values are short codes in the data; these are their
// display labels (the old modal's "Purchase Options" vocabulary).
export const purchaseLabel = (value: string, t: TranslateFn): string => {
  switch (value) {
    case 'online':
      return t('directory.purchase.buyOnline', 'Buy online')
    case 'clinic':
      return t('directory.purchase.localClinic', 'Local clinic')
    case 'telehealth':
      return t('directory.purchase.telehealth', 'Telehealth')
    case 'home':
      return t('directory.purchase.proDelivery', 'Pro delivery')
    default:
      return value
  }
}
